import React from 'react';
import Icon, { IconProps } from './Icon';

// Outline storefront icon for "Shop All" in the Shop navigation list.
const StorefrontIcon: React.FC<IconProps> = ({ size = 24, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M4 10L6 4H18L20 10"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5 10V20H19V10"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9 20V14H15V20"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M4 10C4 11.1046 4.89543 12 6 12C7.10457 12 8 11.1046 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 11.1046 16.8954 12 18 12C19.1046 12 20 11.1046 20 10"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default StorefrontIcon;


